export enum ChatEvents {
  ChatCreated = 'chat_created',
  ChatMessageCreated = 'chat_message_created',
  ChatMessageUpdated = 'chat_message_updated',
  ChatMessageDeleted = 'chat_message_deleted',
  ChatParticipantCreated = 'chat_participant_created',
}
